export default __webpack_public_path__ + "static/media/player_win.84e3e97f.gif";